module.exports = __webpack_public_path__ + "static/bpm-34701160068e2786f7364c24e4816f5a.jpg";